import type { IconProps } from './types';

function PackageIcon(props: IconProps) {
  const { size = 32, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.875 13.1219H16.9V5.875H22.4261L26.125 11.0092V26.125H5.875V11.0092L9.57395 5.875H15.1V13.1219H8.125V23.875H23.875V13.1219ZM21.85 22.075H17.8V19.825H21.85V22.075Z"
        fill={color}
      />
    </svg>
  );
}

export { PackageIcon };
